module.exports = __webpack_public_path__ + "img/ivan-belikov-guitar.0889c05.jpg";